// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-bank .add-bank-body {
  width: 100%;
  transition: 1s;
}
.add-bank .add-bank-body.no-tutorial {
  width: 100%;
}
.add-bank .add-bank-body .ant-steps {
  max-width: 37.5rem;
}
.add-bank .add-bank-body .steps-content {
  margin: 2.5rem 0;
  margin-bottom: 8rem !important;
}
@media (max-width: 768px) {
  .add-bank .add-bank-body .steps-content {
    margin: 1rem 0;
    margin-bottom: 4rem !important;
  }
  .add-bank .add-bank-body .steps-content .bank-account-alert {
    margin-bottom: 1.5rem;
  }
}
.add-bank .add-bank-body .divider {
  margin-top: -0.625rem;
}
.add-bank .add-bank-body .statement-area {
  margin-bottom: 1.5rem;
}
.add-bank .add-bank-body .statement-area .statement-area-title {
  margin-bottom: 0.25rem !important;
}
.add-bank .add-bank-body .statement-area .statement-area-subtitle {
  margin-bottom: 0.75rem !important;
}
.add-bank .add-bank-body .statement-area .uploaded-file-icon {
  cursor: pointer;
  width: 12rem;
  height: 8rem;
  border: 0.063rem solid var(--primary-color);
  font-size: 4rem !important;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-bank .add-bank-body .open-helper-button {
  display: none !important;
}
@media (max-width: 768px) {
  .add-bank .add-bank-body .open-helper-button {
    display: inline !important;
  }
}
@media (max-width: 768px) {
  .add-bank .add-bank-body {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/BankAccountForm/styles.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;EACA,cAAA;AAAJ;AAEI;EACE,WAAA;AAAN;AANA;EAUM,kBAAA;AADN;AATA;EAcM,gBAAA;EACA,8BAAA;AAFN;AAIM;EAAA;IACE,cAAA;IACA,8BAAA;EADN;EADI;IAKI,qBAAA;EADR;AACF;AAtBA;EA4BM,qBAAA;AAHN;AAzBA;EAoDM,qBAAA;AAxBN;AA5BA;EAiCQ,iCAAA;AAFR;AA/BA;EAqCQ,iCAAA;AAHR;AAlCA;EAyCQ,eAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;EACA,0BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AA7CA;EAwDM,wBAAA;AARN;AAUM;EAAA;IACE,0BAAA;EAPN;AACF;AAUI;EAAA;IACE,sBAAA;EAPJ;AACF","sourcesContent":[".add-bank {\n  .add-bank-body {\n    width: 100%;\n    transition: 1s;\n\n    &.no-tutorial {\n      width: 100%;\n    }\n\n    .ant-steps {\n      max-width: 37.5rem;\n    }\n\n    .steps-content {\n      margin: 2.5rem 0;\n      margin-bottom: 8rem !important;\n\n      @media (max-width: @md-screen) {\n        margin: 1rem 0;\n        margin-bottom: 4rem !important;\n\n        .bank-account-alert {\n          margin-bottom: 1.5rem;\n        }\n      }\n    }\n\n    .divider {\n      margin-top: -0.625rem;\n    }\n\n    .statement-area {\n      .statement-area-title {\n        margin-bottom: 0.25rem !important;\n      }\n\n      .statement-area-subtitle {\n        margin-bottom: 0.75rem !important;\n      }\n\n      .uploaded-file-icon {\n        cursor: pointer;\n        width: 12rem;\n        height: 8rem;\n        border: 0.063rem solid var(--primary-color);\n        font-size: 4rem !important;\n        background-color: #f0f0f0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      margin-bottom: 1.5rem;\n    }\n\n    .open-helper-button {\n      display: none !important;\n\n      @media (max-width: @md-screen) {\n        display: inline !important;\n      }\n    }\n\n    @media (max-width: @md-screen) {\n      width: 100% !important;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
